import React from 'react';
import { m } from 'framer-motion';
import { StarIcon, PackageCheckIcon, ShoppingBagIcon, TimerIcon, TrendingUpIcon, UsersIcon, SparklesIcon, TruckIcon, HammerIcon } from 'lucide-react';
import { ScrollHintTable } from '../ui/ScrollHintTable';
const stats = [{
  icon: StarIcon,
  value: '4.9/5',
  label: '+320 Manitas y Carpinteros facturando'
}, {
  icon: PackageCheckIcon,
  value: '+5.200',
  label: 'Piezas vendidas en España'
}, {
  icon: ShoppingBagIcon,
  value: '+1.200',
  label: 'Ventas en Wallapop y Etsy'
}, {
  icon: TimerIcon,
  value: '-12 horas',
  label: 'Ahorradas a la semana'
}, {
  icon: TrendingUpIcon,
  value: '+400€',
  label: 'Ingresos extra promedio / mes'
}];
const trustBadges = [{
  icon: UsersIcon,
  title: 'Para Todos los Niveles',
  text: 'No necesitas ser maestro ebanista. Si sabes usar una cinta métrica y una sierra, puedes hacerlo.'
}, {
  icon: SparklesIcon,
  title: 'Diseño que el Mercado PAGA',
  text: 'Olvida competir con IKEA. Productos con estética Nórdica y Montessori que decoradores en España compran con gusto.'
}, {
  icon: TruckIcon,
  title: 'Logística Inteligente',
  text: 'Productos diseñados para enviarse por Correos o Wallapop por apenas 5€, maximizando tu beneficio neto.'
}, {
  icon: HammerIcon,
  title: 'Herramientas que YA TIENES',
  text: 'Taladro, caladora, lijadora. Eso es todo. Sin máquinas industriales de 3.000€.'
}];
export function TrustStats() {
  return <section className="border-y border-brown/10 bg-bg-secondary py-8 sm:py-10" data-id="element-215" data-mp="1rryaidgurtkx">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-216" data-mp="1ws2r03hrgob5">
        <ScrollHintTable minWidth="760px" data-id="element-217" data-mp="1ituolg1ygusl">
          <div className="grid grid-cols-5 divide-x divide-brown/15" data-id="element-218" data-mp="1istdxcouqabe">
            {stats.map((stat, i) => <m.div key={stat.label} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: i * 0.06
          }} className="flex flex-col items-center gap-2 px-3 py-6 text-center" data-id="element-219" data-mp="1mwr8da38ewy4" data-mpi={i}>
                <stat.icon size={22} className="text-brown" data-id="element-220" data-mp="2944xpzjeot29" />
                <span className="font-heading text-xl font-bold text-ink sm:text-2xl" data-id="element-221" data-mp="24c3lgdm8n2c8">{stat.value}</span>
                <span className="text-xs text-muted sm:text-sm" data-id="element-222" data-mp="1zdk1ujv4a2n1">{stat.label}</span>
              </m.div>)}
          </div>
        </ScrollHintTable>

        <p className="mt-6 text-center font-heading text-sm font-bold uppercase tracking-wider text-success" data-id="element-223" data-mp="1vczz90rry6ti">
          ✓ El Estándar de Rentabilidad para el Artesano Moderno
        </p>

        <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-4" data-id="element-224" data-mp="1le10qb0q3rk8">
          {trustBadges.map((badge, i) => <m.div key={badge.title} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.08
        }} className="flex items-start gap-3 rounded-2xl border border-brown/20 bg-white p-5 shadow-card" data-id="element-225" data-mp="1ggiu4ra6hofe" data-mpi={i}>
              <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg bg-brown/10" data-id="element-226" data-mp="3n9qd8w6qao9x">
                <badge.icon size={20} className="text-brown" data-id="element-227" data-mp="3s2jjjohui4o4" />
              </div>
              <div data-id="element-228" data-mp="u5g08uhxib6">
                <p className="font-heading text-sm font-bold text-ink" data-id="element-229" data-mp="uozvv3pigru">{badge.title}</p>
                <p className="mt-1 text-sm leading-relaxed text-muted" data-id="element-230" data-mp="30c6f9dzjpc27">{badge.text}</p>
              </div>
            </m.div>)}
        </div>
      </div>
    </section>;
}